module.exports = __webpack_public_path__ + "img/188.bf918f18.jpg";